export var breakpoints = Object.freeze({
  mobileSmall: '320px',
  mobileLarge: '600px',
  tabletSmall: '768px',
  tabletLarge: '840px',
  desktopSmall: '1024px',
  desktopMedium: '1300px',
  desktopLarge: '1440px'
});
export var breakpointsAsNumber = Object.freeze({
  mobileSmall: 320,
  mobileLarge: 600,
  tabletSmall: 768,
  tabletLarge: 840,
  desktopSmall: 1024,
  desktopMedium: 1300,
  desktopLarge: 1440
});
export var device = {
  mobileSmall: "(min-width: ".concat(breakpoints.mobileSmall, ")"),
  mobileLarge: "(min-width: ".concat(breakpoints.mobileLarge, ")"),
  tabletSmall: "(min-width: ".concat(breakpoints.tabletSmall, ")"),
  tabletLarge: "(min-width: ".concat(breakpoints.tabletLarge, ")"),
  desktopSmall: "(min-width: ".concat(breakpoints.desktopSmall, ")"),
  desktopMedium: "(min-width: ".concat(breakpoints.desktopMedium, ")"),
  desktopLarge: "(min-width: ".concat(breakpoints.desktopLarge, ")")
};